(() => {
  if (customElements.get('mp-component-specs')) return;
  customElements.define('mp-component-specs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.mp-component-specs__track');
      this.slides = [...this.querySelectorAll('.mp-component-slide')];
      this.nav = this.querySelector('.mp-component-specs__nav');
      this.picker = this.querySelector('[data-spec-picker]');
      this.picker.replaceChildren();
      this.prev = this.querySelector('[data-spec-prev]');
      this.next = this.querySelector('[data-spec-next]');
      this.status = this.querySelector('[data-spec-status]');
      this.index = 0;
      try { this.variantMap = JSON.parse(this.querySelector('[data-spec-variants]').textContent); } catch { this.variantMap = {}; }
      this.buttons = this.slides.map((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'mp-component-specs__option';
        slide.id = 'mp-spec-' + this.dataset.productId + '-' + i;
        button.setAttribute('aria-controls', slide.id);
        const title = slide.querySelector('h3').textContent.trim();
        button.setAttribute('aria-label', 'Technische Daten: ' + title);
        const image = slide.querySelector('img');
        if (image) {
          const thumbnail = document.createElement('img');
          thumbnail.src = image.currentSrc || image.src; thumbnail.alt = ''; thumbnail.width = 48; thumbnail.height = 48; thumbnail.loading = 'lazy';
          button.append(thumbnail);
        }
        const label = document.createElement('span'); label.textContent = title; button.append(label);
        button.addEventListener('click', () => this.goTo(this.visible().indexOf(slide)));
        this.picker.append(button); return button;
      });
      this.prev.onclick = () => this.goTo(this.index - 1);
      this.next.onclick = () => this.goTo(this.index + 1);
      this.onScroll = () => this.sync();
      this.onKey = event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.visible().length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1));
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKey);
      this.onVariant = event => {
        if (String(event.detail?.productId) === this.dataset.productId) this.filter(event.detail.variant);
      };
      document.addEventListener('mp:product-variant-change', this.onVariant);
      let lastWidth = 0;
      this.resize = new ResizeObserver(() => {
        if (this.track.clientWidth !== lastWidth) {
          lastWidth = this.track.clientWidth; this.track.scrollLeft = this.index * lastWidth;
        }
        this.sync();
      });
      this.resize.observe(this.track);
      this.slides.forEach(slide => this.resize.observe(slide));
      try { this.filter(JSON.parse(this.querySelector('[data-spec-initial]').textContent)); } catch { this.sync(); }
    }
    visible() { return this.slides.filter(slide => !slide.hidden); }
    sync() {
      const visible = this.visible();
      if (!visible.length) return;
      this.index = Math.max(0, Math.min(visible.length - 1, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1))));
      const active = visible[this.index];
      this.prev.disabled = this.index === 0; this.next.disabled = this.index === visible.length - 1;
      this.nav.hidden = visible.length < 2;
      this.status.textContent = (this.index + 1) + ' / ' + visible.length;
      const height = active.getBoundingClientRect().height;
      if (height && this.track.style.height !== height + 'px') this.track.style.height = height + 'px';
      this.slides.forEach((slide, i) => {
        slide.inert = slide !== active;
        this.buttons[i].hidden = slide.hidden;
        this.buttons[i].setAttribute('aria-pressed', String(slide === active));
      });
      const selected = this.buttons[this.slides.indexOf(active)];
      if (this.lastActive !== selected) {
        this.picker.scrollTo({ left: Math.max(0, selected.offsetLeft - (this.picker.clientWidth - selected.offsetWidth) / 2), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
        this.lastActive = selected;
      }
    }
    goTo(index) {
      const target = Math.max(0, Math.min(this.visible().length - 1, index));
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    }
    filter(variant) {
      const skus = this.variantMap[String(variant?.id)]?.filter(Boolean);
      const text = Array.isArray(variant?.bundle_items) ? variant.bundle_items.join('|') : '';
      const matches = this.slides.filter(slide => skus?.length ? skus.includes(slide.dataset.componentSku) : text.includes('SKU ' + slide.dataset.componentSku + ')'));
      if (matches.length) {
        const active = this.visible()[this.index];
        this.slides.forEach(slide => slide.hidden = !matches.includes(slide));
        this.index = Math.max(0, matches.indexOf(active));
        this.track.scrollLeft = this.index * this.track.clientWidth;
      }
      this.sync();
    }
    disconnectedCallback() {
      this.resize?.disconnect(); document.removeEventListener('mp:product-variant-change', this.onVariant);
      this.track?.removeEventListener('scroll', this.onScroll); this.track?.removeEventListener('keydown', this.onKey); this.ready = false;
    }
  });
})();

